import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { citiesService } from '../../_services/cities.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
);

class ProvinceSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
      provinceId: this.props.provinceId,
      value: this.props.defaultValue || {},
    };

  }
  // componentWillMount() {
  //   if (this.state.provinceId) {
  //     this.getData(this.state.provinceId)
  //   }
  // }
  componentDidMount() {
    this.getData(this.props.provinceId)
  }

  componentWillReceiveProps(nextProps) {
    // // console.log(nextProps.provinceId);

    if (nextProps.provinceId && nextProps.provinceId !== this.state.provinceId) {
      var provinceId = nextProps.provinceId;

      this.setState({ provinceId: provinceId })

      this.getData(provinceId);
    }

    if (nextProps.defaultValue !== this.state.value) {

      this.setState({ value: nextProps.defaultValue });

    }
  }

  getData = async (provinceId) => {
    // // console.log(provinceId);
    this.setState({ loading: true });

    await citiesService.getAll(provinceId)
      .then((res) => {
        // // console.log(res.data)
        let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))

        this.setState({ data: data, loading: false });
      })
      .catch((error) => {
        this.handleError(error)
      });
  };

  handleError(error) {
    this.setState({ loading: false });
    // toastr.warning('مشکلی پیش آمد', error);
  }

  handleChange = e => {
    this.props.onChange(e);
  }

  render() {
    const customStyles = {
      // option: (provided, state) => ({
      //   ...provided,
      //
      // }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        // height: 40,
        boxShadow: 'none',
        border: 'none',
        paddingRight: '12',
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),

    }
    const { loading, data, provinceId, value } = this.state;
    const { disabled, className, isClearable } = this.props;

    return (
      <ReactSelect
        isClearable={isClearable}
        isDisabled={provinceId ? false : true}
        placeholder=""
        styles={customStyles}
        options={data}
        onChange={this.handleChange}
        value={value ? data.filter(el => el.value === value) : null}
        className={className ? className : "select"}
        isLoading={loading}
        noOptionsMessage={() => "نتیجه ای یافت نشد"}
        loadingMessage={() => "در حال دریافت اطلاعات از سرور"}
      />
    );
  }
}
export default ProvinceSelect;
